import { render } from "./RecCardContent.vue?vue&type=template&id=5ee6dce1&scoped=true"
const script = {}

import "./RecCardContent.vue?vue&type=style&index=0&id=5ee6dce1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee6dce1"]])

export default __exports__